module.exports = __webpack_public_path__ + "img/heat-meter-counter-md.d449c072.svg";